
import { useState } from "react";
import { useAuth } from "@/contexts/auth";
import { Company } from "@/types";
import { UserRole } from "@/types/enums";
import { EditCompanyDialog } from "@/components/companies/EditCompanyDialog";
import { CompanyHeader } from "@/components/companies/CompanyHeader";
import { CompanyCard } from "@/components/companies/CompanyCard";
import { DeleteCompanyDialog } from "@/components/companies/DeleteCompanyDialog";
import { AccessDenied } from "@/components/companies/AccessDenied";
import { useCompanies } from "@/hooks/useCompanies";
import { useCompanyDelete } from "@/hooks/useCompanyDelete";

const Companies = () => {
  const { user } = useAuth();
  const [currentCompany, setCurrentCompany] = useState<Company | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  
  const {
    companies,
    isLoading,
    addCompany,
    updateCompany,
    removeCompany
  } = useCompanies();
  
  const {
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    isDeleting,
    handleConfirmDeleteCompany,
    handleDeleteCompany
  } = useCompanyDelete((deletedId) => removeCompany(deletedId));
  
  // Check if user is app owner
  if (user?.role !== UserRole.APP_OWNER) {
    return <AccessDenied />;
  }
  
  const handleCompanyAdded = (company: Company) => {
    addCompany(company);
  };
  
  const handleEditCompany = (company: Company) => {
    setCurrentCompany(company);
    setIsEditDialogOpen(true);
  };
  
  const handleCompanyUpdated = (updatedCompany: Company) => {
    updateCompany(updatedCompany);
  };
  
  return (
    <div className="space-y-6">
      <CompanyHeader onCompanyAdded={handleCompanyAdded} />
      
      <CompanyCard
        companies={companies}
        isLoading={isLoading}
        onEdit={handleEditCompany}
        onDelete={handleConfirmDeleteCompany}
      />
      
      <EditCompanyDialog
        company={currentCompany}
        isOpen={isEditDialogOpen}
        onClose={() => setIsEditDialogOpen(false)}
        onCompanyUpdated={handleCompanyUpdated}
      />

      <DeleteCompanyDialog
        isOpen={isDeleteDialogOpen}
        onOpenChange={setIsDeleteDialogOpen}
        onDelete={handleDeleteCompany}
        isDeleting={isDeleting}
      />
    </div>
  );
};

export default Companies;
